import React, { forwardRef } from 'react';
import Paper from '~/Common-Objects/UI/Paper/Paper';
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx';
import Toggle from '~/Common-Objects/UI/Forms/Toggle/Toggle';

const SettingTemplate = forwardRef(({ header, subheader, className, setEnabled, enabled, disabled, children }, ref) => {
    const headerStyle = {
        fontWeight: 600,
        fontSize: 16,
        lineHeight: '24px',
        letterSpacing: '-0.24px',
        color: 'var(--neutral-950)'
    }
    const subheaderStyle = {
        fontWeight: 400,
        fontSize: 14,
        lineHeight: '20px',
        letterSpacing: 0,
        color: 'var(--neutral-800)'
    }
    return (
        <Paper className={'settingTemplate ' + (className || '')}>
            <div className="settingTemplate__title" style={{ marginBottom: enabled ? 16 : 0 }} ref={ref}>
                <div style={{ flexGrow: 1 }}>
                    <div style={headerStyle}>{header}</div>
                    {!!subheader && <div style={subheaderStyle}>{subheader}</div>}
                </div>
                {!disabled && <Toggle checked={enabled} onChange={() => setEnabled(!enabled)} />}
                {!!disabled && <SquareChip for={header} tooltip={disabled}>Unavailable</SquareChip>}
            </div>
            <div className={"settingTemplate__content " + (enabled ? 'show' : 'hide')}>
                {children}
            </div>
        </Paper>
    )
})

export default SettingTemplate